import { render, staticRenderFns } from "./business-password.vue?vue&type=template&id=022d6d91"
import script from "./business-password.vue?vue&type=script&lang=js"
export * from "./business-password.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports